<template>
  <div :class="_.container">
    <div v-if="showSearch || showFilter" :class="_.filter">
      <div v-if="showSearch" :class="[_.search, 'van-hairline--bottom']">
        <form :class="_.form" action="." @submit.prevent.stop="handleSearch">
          <dmbc-base-icon name="search" :class="_.icon" />
          <input
            v-model="keyword"
            :class="_.input"
            type="search"
            placeholder="输入关键词搜索"
          />
          <img
            v-show="keyword.length"
            v-track="{
              name: '清空',
              id: 'cldtvs8er0000ysrl9n4zdnbd',
            }"
            :src="require('./images/清空.png')"
            :class="_.clear"
            @click="handleClearClick"
          />
        </form>
        <div
          v-track="{
            name: '搜索',
            id: 'cldtvshz30002ysrl8lu90vba',
          }"
          :class="_.button"
          @click="handleSearch"
        >
          搜索
        </div>
      </div>
      <div v-if="showFilter" :class="_.condition">
        <div
          v-track="{
            name: '综合',
            id: 'cldtvsomg0004ysrl2kwocj7h',
          }"
          :class="[_.item, filterIndex === 0 && _.active]"
          @click="filterIndex = 0"
        >
          综合
        </div>
        <div
          v-track="{
            name: '价格',
            id: 'cldtvsuin0006ysrl974m3mtt',
          }"
          :class="[
            _.item,
            _.hasOrder,
            (filterIndex === 1 || filterIndex === 2) && _.active,
            _[filterIndex === 1 ? 'asc' : 'desc'],
          ]"
          @click="filterIndex = filterIndex === 1 ? 2 : 1"
        >
          价格
        </div>
        <div
          v-track="{
            name: '销量',
            id: 'cldtvszsc0008ysrl6ws50ts5',
          }"
          :class="[
            _.item,
            _.hasOrder,
            (filterIndex === 3 || filterIndex === 4) && _.active,
            _[filterIndex === 3 ? 'asc' : 'desc'],
          ]"
          @click="filterIndex = filterIndex === 3 ? 4 : 3"
        >
          销量
        </div>
      </div>
    </div>
    <dmbc-base-waterfall ref="waterfall" :load="handleDataLoad">
      <template #default="{ data }">
        <slot :data="data">
          <dmbc-base-masonry :col-count="2" :gap="7" :class="_.list">
            <dmbc-base-resource
              v-for="(item, index) in data"
              :key="`${item.id}_${index}`"
              :item="item"
              :track="{
                name: '资源列表',
                id: 'cldtvv2m9000aysrld0frhzsx',
                index: index,
              }"
            />
          </dmbc-base-masonry>
        </slot>
      </template>
    </dmbc-base-waterfall>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      showSearch: {
        type: Boolean,
        default: true,
      },
      showFilter: {
        type: Boolean,
        default: true,
      },
      load: {
        type: Function,
        required: true,
      },
    },

    data: () => ({
      filterIndex: 0,
      keyword: '',
    }),

    watch: {
      filterIndex() {
        this.$refs.waterfall.reload()
      },
    },

    methods: {
      handleSearch() {
        this.$refs.waterfall.reload()
      },

      handleClearClick() {
        this.keyword = ''
      },

      handleDataLoad({ pageNumber }) {
        return this.load({
          keyword: this.keyword,
          pageIndex: pageNumber,
          pageSize: 10,
          sortType:
            this.filterIndex === 1 || this.filterIndex === 2
              ? 'price'
              : this.filterIndex === 3 || this.filterIndex === 4
              ? 'sales'
              : undefined,
          direction:
            this.filterIndex === 1 || this.filterIndex === 3
              ? 'asc'
              : this.filterIndex === 2 || this.filterIndex === 4
              ? 'desc'
              : undefined,
        })
      },
    },
  })
</script>

<style lang="scss" module="_">
  .container {
    .search {
      display: flex;
      align-items: center;
      padding: 12px 0 12px 12px;

      .form {
        flex-grow: 1;
        display: flex;
        align-items: center;
        height: 34px;
        background: #f5f5f5;
        border-radius: 100px;
        padding: 0 12px;

        .icon {
          margin-right: 8px;
          flex-shrink: 0;
          font-size: 16px;
          color: #999;
        }

        .input {
          appearance: none;
          box-shadow: none;
          border: none;
          border-radius: 0;
          outline: none;
          background-color: transparent;

          flex-grow: 1;
          font-size: 14px;
          color: #333;
          line-height: 20px;

          &::placeholder {
            color: #888888;
          }

          /* clears the 'X' from Internet Explorer */
          &::-ms-clear,
          &::-ms-reveal {
            display: none;
            width: 0;
            height: 0;
          }

          /* clears the 'X' from Chrome */
          &::-webkit-search-decoration,
          &::-webkit-search-cancel-button,
          &::-webkit-search-results-button,
          &::-webkit-search-results-decoration {
            display: none;
          }
        }

        .clear {
          flex-shrink: 0;
          width: 22px;
          height: 22px;
        }
      }

      .button {
        flex-shrink: 0;
        padding: 0 12px;
        font-size: 16px;
        font-weight: bold;
        color: #ff111c;

        &:active {
          opacity: 0.9;
        }
      }
    }

    .filter {
      position: sticky;
      top: 0;
      background: #ffffff;
      z-index: 1;

      .condition {
        height: 44px;
        display: flex;
        align-items: center;
        padding: 0 12px;
      }

      .item {
        font-size: 14px;
        color: #999999;
        line-height: 20px;
        display: flex;
        align-items: center;

        + .item {
          margin-left: 40px;
        }

        &.hasOrder {
          &::after {
            content: '';
            display: block;
            width: 14px;
            height: 14px;
            background-image: url('./images/排序_无.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
          }
        }

        &.active {
          color: #ff111c;

          &.hasOrder {
            &.asc {
              &::after {
                background-image: url('./images/排序_升序.png');
              }
            }

            &.desc {
              &::after {
                background-image: url('./images/排序_降序.png');
              }
            }
          }
        }
      }
    }

    .list {
      padding: 12px;
    }
  }
</style>
